import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import Button from 'client/components/aria/Button/Button';
import SnackBar from 'client/components/ui/Snackbar/SnackBar';

import Icon from '@mdi/react';
import { mdiClose } from '@mdi/js';

import { setTimedContent } from 'client/store/alertSlice/alertSlice';

import styles from '../button.module.scss';
import { useEffect, useState } from 'react';

export const TimedAlertSnackBar = () => {
    const intl = useIntl();
    const dispatch = useDispatch();
    const timedMessage = useSelector(state => state?.alert?.timedContent);
    const severity = useSelector(state => state?.alert?.timedSeverity);
    const [timeOut, setTimeOut] = useState(null);

    const handleClose = () => {
        clearTimeout(timeOut);
        dispatch(setTimedContent());
    };

    useEffect(() => {
        if (timedMessage) {
            setTimeOut(
                setTimeout(() => {
                    dispatch(setTimedContent());
                }, 10_000)
            );
        }
    }, [timedMessage]);

    const closeButton = <Button
        data-testid="bookmarkSnackBar.close"
        variant="transparent"
        className={styles.button}
        onClick={handleClose}
        aria-label={intl.formatMessage({ id: 'general.closeNotification' })}
    >
        <Icon path={mdiClose} size={1}/>
    </Button>;

    return (timedMessage
        ? <SnackBar data-testid="snackBar.alert" variant={severity} endOfLine={closeButton}>
            {timedMessage}
        </SnackBar>
        : null
    );
};
